import React from "react";
import { Link } from "react-router-dom";

const listContent = [
 " Marketing-Material (individualisiert)",
"Kassenanbindung an Vorbestellungssoftware",
"Geräteanbindung für digitale Vorbestellung",
"Rentabilität mit Ihnen kalkulieren",
"Supportleistungen",
"Vor-Ort Integration in Ihr Ladengeschäft",
"Mitarbeiterschulungen"
];

const ListTwo = () => {
  return (
    <ul
      className="ptf-services-list ptf-services-list--style-5"
      style={{ "--ptf-font-family": "var(--ptf-primary-font)" }}
    >
      {listContent.map((val, i) => (
        <li key={i}>
          <Link to="/service">{val}</Link>
        </li>
      ))}
    </ul>
  );
};

export default ListTwo;
